import { render, staticRenderFns } from "./CantonIndexView.vue?vue&type=template&id=f28e0804"
import script from "./CantonIndexView.vue?vue&type=script&lang=js"
export * from "./CantonIndexView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports